import type { ReactNode } from 'react';

type LegalSectionProps = {
  index: number;
  title: string;
  children: ReactNode;
};

export default function LegalSection({ index, title, children }: LegalSectionProps) {
  return (
    <article>
      <h2 className="text-lg md:text-xl font-bold text-foreground-950 flex items-start gap-3">
        <span className="mt-1 w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 text-xs font-bold">
          {index}
        </span>
        {title}
      </h2>
      <div className="mt-4 pl-0 md:pl-9 space-y-3">{children}</div>
    </article>
  );
}